import React, { useEffect } from 'react';
import { motion, useSpring } from 'framer-motion';
import PropTypes from 'prop-types';
import { useInView } from 'react-intersection-observer';
import { SCREEN_SIZES } from 'style';

const FadeUpWrapper = ({
  children,
  delay = 0,
  damping = 20,
  mass = 1,
  yDelta = 20,
  ...props
}) => {
  const { ref, inView } = useInView({ rootMargin: `-${window.innerHeight * 0.1}px` });

  const springConfig = { stiffness: 300, damping, mass };
  const opacity = useSpring(0, springConfig);
  const y = useSpring(yDelta, springConfig);

  useEffect(() => {
    if (!inView) return;
    let delayToUse = delay;
    if (window.innerWidth < SCREEN_SIZES.tabletLandscape) {
      delayToUse = 0;
    }
    const t = setTimeout(() => {
      opacity.set(1);
      y.set(0);
    }, delayToUse);
    return () => {
      clearTimeout(t);
    };
  }, [inView, opacity, y, delay]);

  return (
    <motion.div ref={ref} style={{ opacity, y }} {...props}>
      {children}
    </motion.div>
  );
};

FadeUpWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  delay: PropTypes.number,
  damping: PropTypes.number,
  mass: PropTypes.number,
  yDelta: PropTypes.number
};

export default FadeUpWrapper;
